import React, {useEffect, useState} from "react";
import "../../style/custom/welcome.scss";

import {setFormData} from "../../components/manager/form";


import root from "window-or-global";
import { Redirect } from "react-router-dom";

export default function Welcome(props) {
  // const [locationId, setLocationId] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(root.location.search);
    // const locationParam = params.get("locationId") || "";

    const voucherCode = params.get("code");
    // if (!locationParam || locationParam === "" || locationParam === "undefined") {
    //   root.location = "/select-address";
    // }
    setFormData({voucherCode});
    // setLocationId(locationParam);
  }, []);
  return (<Redirect to="/plan"/>);

}
